/**
 * @generated SignedSource<<e0b461d78ced0078a62f718599a62782>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZnglyInfo_PrivacyPolicy_Query$variables = Record<PropertyKey, never>;
export type ZnglyInfo_PrivacyPolicy_Query$data = {
  readonly znglyInfo: {
    readonly znglyInfo: {
      readonly privacyPolicy: string | null | undefined;
      readonly privacyPolicyTitle: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ZnglyInfo_PrivacyPolicy_Query = {
  response: ZnglyInfo_PrivacyPolicy_Query$data;
  variables: ZnglyInfo_PrivacyPolicy_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "id",
    "value": "site-info"
  },
  {
    "kind": "Literal",
    "name": "idType",
    "value": "SLUG"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "ZnglyInfo_Znglyinfo",
  "kind": "LinkedField",
  "name": "znglyInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privacyPolicy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privacyPolicyTitle",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZnglyInfo_PrivacyPolicy_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ZnglyInfo",
        "kind": "LinkedField",
        "name": "znglyInfo",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZnglyInfo_PrivacyPolicy_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ZnglyInfo",
        "kind": "LinkedField",
        "name": "znglyInfo",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
      }
    ]
  },
  "params": {
    "cacheID": "19d2ac265d9e983e2d303f42c0141a7d",
    "id": null,
    "metadata": {},
    "name": "ZnglyInfo_PrivacyPolicy_Query",
    "operationKind": "query",
    "text": "query ZnglyInfo_PrivacyPolicy_Query {\n  znglyInfo(id: \"site-info\", idType: SLUG) {\n    znglyInfo {\n      privacyPolicy\n      privacyPolicyTitle\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b683db2933aff1f81795264c61c75aa";

export default node;
